import React, { useEffect, useState } from 'react';
import { Row, Col, Container, Badge, Card, CardBody, CardHeader, Button } from 'reactstrap';
import styles from './ViewAllAccounts.module.css';
import { ReactComponent as Home } from '../../assets/images/home.svg';
import { useHistory } from 'react-router-dom';
import moment from 'moment';
import { useContext } from 'react';
import { ContractContext } from '../contexts/ContractContext';
import getClientContent from '../_BrandingProvider/brandContent';
import AIGStatusBadge from '../shared/StatusBadge/StatusBadge';

const ViewAllAccounts = () => {
    const context = useContext(ContractContext);
    const {
        data: { clientId }
    } = context;
    const {
        variableText: { customerService }
    } = getClientContent(clientId);

    const [showPlans, setShowPlans] = useState([]);
    const history = useHistory();
    const contracts = context.data?.contracts || [];
    const email = context.data?.party?.partyEmailModel?.[0]?.address || context.data?.planLogin?.email || '';

    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const res = await fetch(`api/contract/FindContractsByEmailAndClient`, {
                    method: 'post',
                    headers: {
                        'Content-Type': 'application/json',
                        Accept: 'application/json'
                    },
                    body: JSON.stringify({
                        clientId: clientId,
                        emailAddress: email,
                        sendEmail: false,
                        emailType: 'ForgotPlanNumber'
                    })
                });
                if (res.ok) {
                    const data = await res.json();
                    setShowPlans(processData(data));
                } else {
                    history.push('/system-error');
                }
            } catch (error) {
                history.push('/system-error');
            }
        };

        if (contracts?.length === 0) {
            fetchPlans();
        } else {
            setShowPlans(processData(contracts));
        }
    }, []);

    const processData = (accountData) => {
        return accountData?.map((data) => {
            const { firstName, lastName } = data?.party;
            const partyName = `${firstName} ${lastName}`;
            const statusId = data?.statusId;
            const planName = data?.riskProfile?.name;
            const address1 = data?.party?.serviceAddress?.address1;
            const city = data?.party?.serviceAddress?.city;
            const state = data?.party?.serviceAddress?.state;
            const zip = data?.party?.serviceAddress?.zip;
            const address2 = data?.party?.serviceAddress?.address2;
            const serviceAddress =
                data?.party?.serviceAddress
                && `${address1 && address1 + ', '}${address2 && address2 + ', '}${city && city + ',  '}${state && state + ' '}${zip && zip}`;
            const clientContractNumber = data?.clientContractNumber;
            const contractNumber = data?.contractNumber;
            const clientId = data?.clientId;
            const planStartDate = data?.contractAssetModel[0]?.contractAssetCoverageModel[0]?.enforcementDate;
            return {
                ...data,
                partyName,
                statusId,
                planName,
                serviceAddress,
                clientContractNumber,
                planStartDate,
                contractNumber,
                clientId
            };
        });
    };

    const viewPlan = (plan) => {
        const pathName = '/planoverview';
        let value = context;
        value.updateContract(plan);
        value.updateParty(plan.party);
        history.push({
            pathname: pathName,
            state: {
                accountDetailsUpdated: true,
                updatedPartyName: plan
            }
        });
    };

    return (
        <div>
            <section className={styles.planhero}>
                <Container>
                    <Row>
                        <Col
                            md={5}
                            lg={7}
                        >
                            <h1>My Plans</h1>
                        </Col>
                    </Row>
                </Container>
            </section>
            <section>
                <Container>
                    <Row className={styles.cardContainer}>
                        {showPlans?.map((plan) => {
                            return (
                                <Col
                                    md={6}
                                    lg={6}
                                    className={styles.columnPadding}
                                >
                                    <Card className={styles.card}>
                                        <CardHeader className={styles.cardHeader}>
                                            <h3>{plan?.planName}</h3>
                                            <AIGStatusBadge
                                                statusId={plan?.statusId}
                                                statusType='contract'
                                            />
                                        </CardHeader>
                                        <CardBody className={styles.cardBody}>
                                            <Col className='p-0'>
                                                <ul className='noBullets'>
                                                    <li>{plan?.partyName}</li>
                                                    <li>
                                                        Plan Start:{' '}
                                                        <span>{moment(plan?.planStartDate).format('MM/DD/YYYY')}</span>
                                                    </li>
                                                    <li>
                                                        Service Address: <span>{plan?.serviceAddress}</span>
                                                    </li>
                                                    <li>
                                                        Contract: #<span>{plan?.clientContractNumber}</span>
                                                    </li>
                                                </ul>
                                                <Button
                                                    color='secondary'
                                                    onClick={(e) => viewPlan(plan)}
                                                >
                                                    View Plan
                                                </Button>
                                            </Col>
                                            <Home className={styles.cardIcon} />
                                        </CardBody>
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                    <p className={styles.contactInfo}>
                        Incorrect plan? Call us at
                        <a
                            href={`tel:${customerService?.phone}`}
                            className='ml-1 callLink'
                            aria-label={`Click to Call ${customerService?.phone}`}
                        >
                            {customerService?.phone}
                        </a>
                        .
                    </p>
                </Container>
            </section>
        </div>
    );
};

export default ViewAllAccounts;
